/* =========================================================================
   Seletor de versão da peça — troca a PDP inteira sem recarregar.

   Ex.: LipLegging "Sem bolso" -> "Com bolso". Galeria, seletores de cor e
   tamanho, preço, reviews, tabela de medidas, medidas da peça, modelos
   vestem, carrossel de benefícios, FAQ: tudo troca.

   POR QUE BUSCAR A PÁGINA INTEIRA E NÃO MONTAR NA MÃO
   Quem sabe renderizar a versão com bolso é a página dela. Buscar o HTML
   pronto e trocar os nós significa que qualquer metacampo novo que alguém
   adicionar no futuro entra na troca de graça, sem tocar neste arquivo.
   Manipular seletor a seletor daria trabalho eterno e quebraria calado.

   POR QUE `?variant=<id>` NA BUSCA
   Em vez de trocar o DOM e depois tentar reaplicar a seleção da cliente, eu
   descubro a variante equivalente no outro produto e peço a página JÁ com ela
   selecionada. Quem monta o estado é o servidor — é o caminho que não
   dessincroniza.

   DELEGAÇÃO NO DOCUMENT, não listener no botão.
   A primeira versão amarrava o clique no botão encontrado no carregamento. Só
   que a troca substitui o #MainContent inteiro: aquele botão morre e o que
   entra no lugar (vindo da página do outro produto) fica sem listener — dava
   para ir e não dava para voltar. Com delegação, qualquer seletor que exista
   no DOM funciona, antes ou depois de quantas trocas forem, e os dados são
   lidos NO MOMENTO do clique, do seletor que está na tela.
   ========================================================================= */

(function () {
  var ocupado = false;

  /* Cache por URL: trocar de ida e volta não deve custar rede duas vezes.
     A cliente costuma comparar as duas versões antes de decidir. */
  var cache = {};

  /* Normalização sem regex de range Unicode.

     A primeira versão usava um range de diacríticos escrito com caracteres
     literais, e o arquivo saiu com bytes UTF-8 crus no lugar do range —
     funcionaria por acaso, e qualquer ferramenta que reescrevesse o arquivo
     (o próprio Shopify, conversão de CRLF) poderia corromper em silêncio.

     Este mapa cobre o que de fato aparece em nome de cor em português. É
     código ASCII puro: não tem como corromper, e é explícito sobre o que
     trata. Se aparecer cor com acento fora da lista, é só acrescentar. */
  var ACENTOS = {
    'á': 'a', 'à': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a',
    'é': 'e', 'è': 'e', 'ê': 'e',
    'í': 'i', 'ì': 'i', 'î': 'i',
    'ó': 'o', 'ò': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
    'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
    'ç': 'c', 'ñ': 'n'
  };

  function normaliza(s) {
    var t = String(s == null ? '' : s).trim().toLowerCase();
    var saida = '';
    for (var i = 0; i < t.length; i++) {
      var c = t.charAt(i);
      saida += ACENTOS[c] || c;
    }
    return saida;
  }

  /* Lê tudo do seletor que está na tela agora. Nunca de uma cópia guardada:
     depois de uma troca, o seletor é outro elemento com outros dados. */
  function contexto(botao) {
    var raiz = botao.closest('[data-tp-versao]');
    if (!raiz) return null;
    var dadosEl = raiz.querySelector('[data-tp-versao-dados]');
    var destino = botao.dataset.tpVersaoTrocar;
    if (!dadosEl || !destino) return null;
    var dados;
    try {
      dados = JSON.parse(dadosEl.textContent);
    } catch (e) {
      return null;
    }
    return {
      botao: botao,
      dados: dados,
      destino: destino,
      trocarUrl: raiz.dataset.trocarUrl === 'true'
    };
  }

  /* Variante selecionada agora: o input do formulário de compra é a fonte da
     verdade, não a URL — a URL pode não ter ?variant= se a cliente não mexeu
     em nada ainda. */
  function opcoesSelecionadas(dados) {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!input || !input.value) return null;
    var id = String(input.value);
    var achou = null;
    dados.atual.variantes.forEach(function (v) {
      if (String(v.id) === id) achou = v.opcoes;
    });
    return achou;
  }

  /* Equivalente no outro produto, em ordem de preferência:
     1. mesma cor + mesmo tamanho, disponível
     2. mesma cor + mesmo tamanho, mesmo esgotada — a página mostra "esgotado",
        que é informação honesta, melhor do que trocar a escolha em silêncio
     3. mesmo tamanho em qualquer cor, disponível
     4. nada: deixa o servidor escolher o padrão */
  function equivalente(dados, opcoes) {
    if (!opcoes) return null;
    var chave = opcoes.map(normaliza).join('|');
    var tamanhoAtual = normaliza(opcoes[opcoes.length - 1]);
    var exata = null;
    var exataEsgotada = null;
    var mesmoTam = null;

    dados.alvo.variantes.forEach(function (v) {
      var k = v.opcoes.map(normaliza).join('|');
      if (k === chave) {
        if (v.disponivel && !exata) exata = v;
        if (!exataEsgotada) exataEsgotada = v;
      }
      var tamAlvo = normaliza(v.opcoes[v.opcoes.length - 1]);
      if (!mesmoTam && v.disponivel && tamanhoAtual === tamAlvo) mesmoTam = v;
    });

    var escolhida = exata || exataEsgotada || mesmoTam;
    return escolhida ? escolhida.id : null;
  }

  function montaUrl(ctx) {
    var id = equivalente(ctx.dados, opcoesSelecionadas(ctx.dados));
    if (!id) return ctx.destino;
    return ctx.destino + (ctx.destino.indexOf('?') === -1 ? '?' : '&') + 'variant=' + id;
  }

  function buscar(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        cache[url] = html;
        return html;
      });
  }

  /* Depois de trocar o DOM, os web components do tema (product-info,
     variant-selects, slider-component, os tp-*) acordam sozinhos no
     connectedCallback ao entrar no documento.

     Quem NÃO acorda é app de terceiro que varreu o DOM no load. O Judge.me é
     o caso concreto: os reviews são por produto e ficariam com os do produto
     anterior. */
  function reinicializar(escopo) {
    try {
      if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
        window.jdgm.customizeBadges();
      }
      if (
        window.jdgm &&
        window.jdgm.batchRenderer &&
        typeof window.jdgm.batchRenderer.renderBadges === 'function'
      ) {
        window.jdgm.batchRenderer.renderBadges();
      }
    } catch (e) {}

    /* Mesmo evento que o editor de temas dispara ao recarregar uma seção:
       código nosso que já escute isso passa a funcionar na troca sem mudança. */
    escopo.querySelectorAll('.shopify-section').forEach(function (sec) {
      document.dispatchEvent(
        new CustomEvent('shopify:section:load', {
          detail: { sectionId: sec.id },
          bubbles: true
        })
      );
    });

    document.dispatchEvent(new CustomEvent('tp:versao:trocada', { bubbles: true }));
  }

  function trocar(ctx) {
    if (ocupado) return;
    ocupado = true;
    ctx.botao.setAttribute('aria-busy', 'true');
    document.documentElement.classList.add('tp-versao-trocando');

    var url = montaUrl(ctx);

    buscar(url)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.querySelector('#MainContent');
        var atual = document.querySelector('#MainContent');
        if (!novo || !atual) throw new Error('MainContent nao encontrado');

        atual.innerHTML = novo.innerHTML;

        // Título da aba acompanha, senão a aba anuncia a versão antiga.
        if (doc.title) document.title = doc.title;

        if (ctx.trocarUrl) history.replaceState({}, '', url);

        reinicializar(atual);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(function () {
        /* Falhou a troca: navega de verdade. Nunca deixar a cliente presa
           numa página que não trocou e sem saber por quê. */
        window.location.href = url;
      })
      .finally(function () {
        ocupado = false;
        document.documentElement.classList.remove('tp-versao-trocando');
        /* O botão que tinha aria-busy morreu junto com o DOM antigo. Limpo em
           qualquer seletor que exista agora, para não sobrar spinner preso
           se a troca falhar e a navegação demorar. */
        document.querySelectorAll('[data-tp-versao-trocar][aria-busy]').forEach(function (b) {
          b.removeAttribute('aria-busy');
        });
      });
  }

  document.addEventListener('click', function (e) {
    var botao = e.target.closest && e.target.closest('[data-tp-versao-trocar]');
    if (!botao) return;
    e.preventDefault();
    var ctx = contexto(botao);
    if (ctx) trocar(ctx);
  });

  /* Pré-carrega no primeiro hover / toque: quando a cliente clicar, o HTML já
     está no cache e a troca é instantânea. Delegado também, para valer nos
     seletores que aparecem depois de uma troca. */
  var jaPrefetch = {};
  function prefetch(e) {
    var botao = e.target.closest && e.target.closest('[data-tp-versao-trocar]');
    if (!botao) return;
    var ctx = contexto(botao);
    if (!ctx) return;
    var url = montaUrl(ctx);
    if (jaPrefetch[url]) return;
    jaPrefetch[url] = true;
    buscar(url).catch(function () {});
  }
  document.addEventListener('mouseover', prefetch);
  document.addEventListener('touchstart', prefetch, { passive: true });
})();
